<template>
    <div>
        <v-container grid-list-xs
        >
            <v-row>
                <v-col>
                    <v-card>
                        <v-card-actions>
                            <BackButton />
                        </v-card-actions>
                        <v-card-text>
                            <v-subheader class="text-subtitle-1 font-weight-bold">1. Overview</v-subheader>
                            <p>
                                This privacy policy applies to your use of products and services offered by Versatile
                                Credit, Inc. ("Versatile", "We", "Our", or "Us"), including use of this website, as well
                                as the electronic consumer credit and leasing applications offered by Versatile. The
                                purpose of this privacy policy ("Privacy Policy") is to inform you about the types of
                                personally identifiable information We gather about you when you visit Our website or
                                use Our products and services, how We may use that information, whether We disclose it
                                to anyone, and the choices you have regarding our use of, and your ability to correct
                                the information. The phrases "personally identifiable information" or "personal
                                information" mean any information by which you can be identified, such as your name,
                                address, telephone number, Social Security number, etc. By using this website or Our
                                products and services, you assent to the terms of this Privacy Policy. Whenever you
                                submit information via Our products and services, you consent to the collection, use and
                                disclosure of that information in accordance with this Privacy Policy. If you do not
                                agree to the terms of our Privacy Policy, please do not submit information to Us.
                            </p>
                            <v-subheader class="text-subtitle-1 font-weight-bold">
                                2. Information You Submit
                            </v-subheader>
                            <p>
                                As a user of Our products and services, you can be assured that at no time will We
                                collect personal information about you unless you voluntarily provide that information
                                to Us. We respect your privacy and will never share any of your personal information
                                with third parties except as provided here. If you submit your personal information to
                                Us for purposes of utilizing Our products and services, including to obtain credit or
                                leasing from third parties, We will share that information with those third parties for
                                that specific purpose. We will also disclose your personal information, without notice,
                                if required to do so by law or in the good faith belief that such action is necessary to
                                (a) conform to the edicts of the law or comply with a legal process served on Us; (b)
                                protect and defend Our rights or property; or, (c) act in urgent circumstances to
                                protect the personal safety of users of Our products or services or the public. We will
                                not use your personal information in a way that is incompatible with these stated
                                purposes, unless We obtain your prior consent.
                            </p>
                            <v-subheader class="text-subtitle-1 font-weight-bold">
                                3. Security and Your Information
                            </v-subheader>
                            <p>
                                We will take reasonable steps to protect your personally identifiable information that
                                you transmit to Us from loss, misuse and unauthorized access, disclosure, alteration or
                                destruction. We maintain physical, electronic and procedural safeguards to ensure that
                                personal information is treated responsibly.
                            </p>
                            <v-subheader class="text-subtitle-1 font-weight-bold">
                                4. Changes to this Privacy Policy
                            </v-subheader>
                            <p>
                                We reserve the right to change this Privacy Policy at any time by posting revisions on
                                Our website or within Our product and services and you agree to any such changes upon
                                your continued use of the website, products or services. When changes are made, we will
                                update the effective date of this Privacy Policy. This Privacy Policy is not intended to
                                and does not create any contractual or other legal rights in or on behalf of any party.
                            </p>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {}
</script>

<style lang="scss" scoped>
    .v-card__text {
        color: #000000 !important;

        .theme--light.v-subheader {
            color: #000000;
        }
    }
</style>
